<template>
	<v-app-bar app dark>
		<v-toolbar-title @click="$router.push({ name:'root' })" style="cursor:pointer" class="mr-4">Signatures App</v-toolbar-title>

		<v-btn :to="{name:'root'}" text exact v-if="isSignedIn">
			<span class="mr-2">Dashboard</span>
		</v-btn>

		<v-btn :to="{name:'user.list'}" text exact v-if="isSignedIn && $store.state.signaturesApiAuth.roles.includes('User.Read')">
			<span class="mr-2">Users</span>
		</v-btn>

		<slot name="navigation">
		</slot>


		<v-spacer></v-spacer>

		<v-divider vertical class="ml-2 mr-4"></v-divider>

		<div v-if="isSignedIn" class="mr-2 text-caption hidden-sm-and-down">
			{{ $store.state.microsoftAuth.name }}
		</div>
		<div v-else class="mr-2 text-caption hidden-sm-and-down">
			Garrett County Government
		</div>

		<v-menu offset-y>
			<template v-slot:activator="{ on, attrs }">
				<v-btn v-bind="attrs" v-on="on" icon>
					<v-icon>mdi-dots-vertical</v-icon>
				</v-btn>
			</template>

			<v-list>
				<v-subheader v-if="isSignedIn">{{ $store.state.microsoftAuth.name }}</v-subheader>

				<v-list-item :to="{'name':'auth.signOut'}" v-if="isSignedIn">
					<v-list-item-content>
						<v-list-item-title>Sign Out</v-list-item-title>
					</v-list-item-content>
					<v-list-item-icon>
						<v-icon small>mdi-logout</v-icon>
					</v-list-item-icon>
				</v-list-item>

				<v-list-item href="https://apps.garrettcountymd.gov/portal"  v-if="isSignedIn">
					<v-list-item-content>
						<v-list-item-title>App Portal</v-list-item-title>
					</v-list-item-content>
					<v-list-item-icon>
						<v-icon small>mdi-cube</v-icon>
					</v-list-item-icon>
				</v-list-item>

				<v-divider v-if="isSignedIn"></v-divider>

				<v-list-item class="no-hover-active">
					<v-list-item-content class="text-caption">
						Signatures App: {{ appVersion }}<br>
						Signatures API: {{ apiVersion }}<br>
						&copy;{{ year }} Garrett County Government
					</v-list-item-content>
				</v-list-item>
			</v-list>
		</v-menu>

	</v-app-bar>
</template>

<script>
export default {
	name: "AppHeaderBar",
	computed:{
		isSignedIn:       function() {
			return this.$store.getters.isSignedIn;
		},
		appVersion:function(){
			return process.env.VUE_APP_APP_VERSION;
		},
		apiVersion:function(){
			return process.env.VUE_APP_API_VERSION;
		},
		year:function() {
			let dt = new Date();
			return dt.getFullYear();
		}
	}
}
</script>

<style scoped>

</style>
